import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {EventTypeService} from '../../../../../../core/services/eventType.service';


@Component({
    selector: 'sub-credit-target-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class SubCreditTargetFormDialogComponent implements OnInit
{
  public formGroup: FormGroup = new FormGroup({
    credit: new FormControl('', Validators.required),
    eventTypeId: new FormControl('', Validators.required),
  });
  action: string;
  dialogTitle;
  subCreditTarget;
  eventTypes;
  remain = 0;
  dataExist;
  defEventTypes;
  chosenEventType;
    constructor(
        public dialogRef: MatDialogRef<SubCreditTargetFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any, private eventTypeService: EventTypeService
    )
    {
      this.eventTypeService.getEventTypeDropDown().subscribe((result: any) => {
        this.defEventTypes = result;
        this.action = data.action;

        if ( this.action === 'edit' )
        {
          this.dialogTitle = 'subCreditTarget.edit';
          this.subCreditTarget = data.type;
        }
        else
        {
          this.dialogTitle = 'subCreditTarget.new';
        }
        this.remain = data.remain;
        this.dataExist = data.data;
        this.eventTypes = [];

        for (let i = 0; i < result.length; i++) {
          let count = 0;
          for (let j = 0; j < this.dataExist.length; j++) {
            if (this.dataExist[j].eventTypeId === result[i].id) {
              count++;
              break;
            }
          }
          if (count === 0) {
            this.eventTypes.push({value: result[ i ].id , label: result[ i ].name});
          }
          if (this.action === 'edit' && result[i].id === this.subCreditTarget.eventTypeId){
            this.eventTypes.push({value: result[ i ].id , label: result[ i ].name});
          }
        }
        this.initForm();
      });

    }

    ngOnInit()
    {
      this.initForm();
    }

  initForm() {
    const selectControl = this.formGroup.get('credit');
    selectControl.setValidators([Validators.max(this.remain), Validators.min(1), Validators.required]);
    if (this.action === 'edit') {
      this.formGroup.patchValue(this.subCreditTarget);
      selectControl.setValidators([Validators.max(this.remain + this.subCreditTarget.credit), Validators.min(1), Validators.required]);
    }
    selectControl?.updateValueAndValidity();
    this.formGroup.get('eventTypeId').valueChanges.subscribe(res => {
      if (res) {
        this.chosenEventType = this.defEventTypes.find(el => +el.id === +res);
      }
    });
  }
}
